import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { CurrentUserService } from '../../../services/currentUser.service';
import { MatButtonModule } from '@angular/material/button';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { UserRepairerSite } from '../../../model/user.model';
import { AccessRepairerSiteComponent } from '../../sysadmin-dashboard/access-repairer-site/access-repairer-site.component';
import { smallModalConfig } from '../../../consts/modal-config.const';
import { ModalConfigsHelper } from '../../../helpers/modal-configs.helper';
import { MatDialog } from '@angular/material/dialog';
import { UnavailabilityTypeEnum } from '../../../consts/unavailability-types';

@Component({
  imports: [CommonModule, MatCardModule, MatButtonModule, MatExpansionModule, MatIconModule, MatMenuModule],
  selector: 'app-mladmin-repairer-sites',
  templateUrl: './mladmin-repairer-sites.component.html',
  styles: [
    `
      section {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
        grid-gap: 20px;
        align-items: stretch;
      }
    `
  ]
})
export class MlAdminRepairerSitesComponent {
  currentUserService = inject(CurrentUserService);
  private modalConfigsHelper = inject(ModalConfigsHelper);
  private matDialog = inject(MatDialog);
  readonly unavailabilityTypeEnum = UnavailabilityTypeEnum;

  accessRepairSite(site: UserRepairerSite) {
    if (site) {
      const data = { repairerSiteId: site.id, repairerSiteName: site.companyName };
      this.matDialog.open(
        AccessRepairerSiteComponent,
        this.modalConfigsHelper.buildMediumModalConfig(data, smallModalConfig)
      );
    }
  }
}
